document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('header[id^="section-"]');
  if (!header) return;

  function getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }

  function lockScroll() {
    const scrollbarWidth = getScrollbarWidth();
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = scrollbarWidth + 'px';
    header.style.paddingRight = scrollbarWidth + 'px';
  }

  function unlockScroll() {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    header.style.paddingRight = '';
  }

  const additionalTextElements = header.querySelectorAll('.header-menu__additional-text');

  let lastScrollTop = 0;
  let ticking = false;

  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop <= 10) {
      header.classList.remove('scrolled');
      additionalTextElements.forEach(el => {
        el.classList.remove('collapsed');
      });
      lastScrollTop = scrollTop;
      return;
    }

    if (scrollTop > lastScrollTop && scrollTop > 100) {
      header.classList.add('scrolled');
      additionalTextElements.forEach(el => {
        el.classList.add('collapsed');
      });
    } else if (scrollTop < lastScrollTop) {
      header.classList.remove('scrolled');
      additionalTextElements.forEach(el => {
        el.classList.remove('collapsed');
      });
    }

    lastScrollTop = scrollTop;
  }

  if (additionalTextElements.length > 0) {
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    handleScroll();
  }

  const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileMenuClose = document.querySelectorAll('[data-mobile-menu-close]');
  const mobileMenuPanels = document.querySelectorAll('[data-mobile-panel]');
  const mobileSubmenuTriggers = document.querySelectorAll('[data-mobile-submenu-trigger]');
  const mobileBackButtons = document.querySelectorAll('[data-mobile-back]');

  let currentMobilePanel = 'main';

  function showMobilePanel(panelId) {
    const mainPanel = document.querySelector('[data-mobile-panel="main"]');
    const targetPanel = document.querySelector(`[data-mobile-panel="${panelId}"]`);

    if (!targetPanel) return;

    mobileMenuPanels.forEach(panel => {
      panel.classList.remove('active');
      if (panel.getAttribute('data-mobile-panel') === 'main') {
        panel.classList.add('hidden');
      }
    });

    if (panelId === 'main') {
      mainPanel.classList.remove('hidden');
    } else {
      targetPanel.classList.add('active');
    }

    currentMobilePanel = panelId;
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('active');
    unlockScroll();

    setTimeout(() => {
      showMobilePanel('main');
    }, 300);
  }

  if (mobileMenuToggle && mobileMenu) {
    mobileMenuToggle.addEventListener('click', function() {
      mobileMenu.classList.add('active');
      lockScroll();
      showMobilePanel('main');
    });

    mobileMenuClose.forEach(closeBtn => {
      closeBtn.addEventListener('click', closeMobileMenu);
    });

    mobileMenu.addEventListener('click', function(e) {
      if (e.target === mobileMenu) {
        closeMobileMenu();
      }
    });
  }

  mobileSubmenuTriggers.forEach(trigger => {
    trigger.addEventListener('click', function() {
      const targetPanel = this.getAttribute('data-mobile-submenu-trigger');
      showMobilePanel(targetPanel);
    });
  });

  mobileBackButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      const targetPanel = this.getAttribute('data-mobile-back');
      showMobilePanel(targetPanel);
    });
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('active')) {
      closeMobileMenu();
    }
  });

  const megaMenuTriggers = document.querySelectorAll('[data-mega-menu-trigger]');
  const megaMenuPanels = document.querySelectorAll('[data-mega-menu-panel]');
  const megaMenuOverlay = document.querySelector('[data-mega-menu-overlay]');

  let activePanel = null;
  const hasMegaMenus = megaMenuTriggers.length && megaMenuPanels.length;

  function openMegaMenu(index) {
    const panel = document.querySelector(`[data-mega-menu-panel="${index}"]`);
    const trigger = document.querySelector(`[data-mega-menu-trigger="${index}"]`);

    if (!panel) return;

    if (activePanel && activePanel !== panel) {
      closeMegaMenu();
    }

    panel.classList.add('active');
    if (megaMenuOverlay) megaMenuOverlay.classList.add('active');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    activePanel = panel;
  }

  function closeMegaMenu() {
    if (!activePanel) return;

    activePanel.classList.remove('active');
    if (megaMenuOverlay) megaMenuOverlay.classList.remove('active');

    megaMenuTriggers.forEach(trigger => {
      trigger.setAttribute('aria-expanded', 'false');
    });

    activePanel = null;
  }

  let megaMenuCloseTimeout = null;

  function clearMegaMenuTimeout() {
    if (megaMenuCloseTimeout) {
      clearTimeout(megaMenuCloseTimeout);
      megaMenuCloseTimeout = null;
    }
  }

  if (hasMegaMenus) {
    megaMenuTriggers.forEach(trigger => {
      trigger.addEventListener('mouseenter', function(e) {
        clearMegaMenuTimeout();
        const index = this.getAttribute('data-mega-menu-trigger');
        openMegaMenu(index);
      });

      trigger.addEventListener('mouseleave', function(e) {
        megaMenuCloseTimeout = setTimeout(() => {
          closeMegaMenu();
        }, 150);
      });
    });

    megaMenuPanels.forEach(panel => {
      panel.addEventListener('mouseenter', function() {
        clearMegaMenuTimeout();
      });

      panel.addEventListener('mouseleave', function() {
        megaMenuCloseTimeout = setTimeout(() => {
          closeMegaMenu();
        }, 150);
      });
    });

    document.querySelectorAll('[data-mega-menu-close]').forEach(closeBtn => {
      closeBtn.addEventListener('click', closeMegaMenu);
    });

    if (megaMenuOverlay) {
      megaMenuOverlay.addEventListener('click', closeMegaMenu);
    }
  }

  if (hasMegaMenus) megaMenuPanels.forEach(panel => {
    const categoryItems = panel.querySelectorAll('[data-category-item]');
    const subcategoriesCol = panel.querySelector('[data-subcategories-col]');
    const subcategoriesPanels = panel.querySelectorAll('[data-subcategories-panel]');

    function showSubcategoriesPanel(panelIndex) {
      if (!subcategoriesCol) return;

      panel.classList.add('mega-menu-panel--expanded');
      subcategoriesCol.classList.add('mega-menu__subcategories-col--visible');

      subcategoriesPanels.forEach(p => {
        if (p.getAttribute('data-subcategories-panel') === String(panelIndex)) {
          p.classList.add('mega-menu__subcategories-panel--active');
        } else {
          p.classList.remove('mega-menu__subcategories-panel--active');
        }
      });
    }

    function hideSubcategoriesCol() {
      if (!subcategoriesCol) return;
      panel.classList.remove('mega-menu-panel--expanded');
      subcategoriesCol.classList.remove('mega-menu__subcategories-col--visible');
      subcategoriesPanels.forEach(p => {
        p.classList.remove('mega-menu__subcategories-panel--active');
      });
    }

    categoryItems.forEach(item => {
      item.addEventListener('mouseenter', function() {
        const categoryIndex = this.getAttribute('data-category-index');
        const hasChildren = this.getAttribute('data-has-children') === 'true';

        categoryItems.forEach(ci => {
          ci.classList.remove('mega-menu__category-item--active');
        });
        this.classList.add('mega-menu__category-item--active');

        if (hasChildren) {
          showSubcategoriesPanel(categoryIndex);
        } else {
          hideSubcategoriesCol();
        }
      });
    });

    panel.addEventListener('mouseleave', function() {
      hideSubcategoriesCol();
      categoryItems.forEach((ci, index) => {
        if (index === 0) {
          ci.classList.add('mega-menu__category-item--active');
        } else {
          ci.classList.remove('mega-menu__category-item--active');
        }
      });
    });

    subcategoriesPanels.forEach(subcatPanel => {
      const subcategoryItems = subcatPanel.querySelectorAll('[data-subcategory-item]');
      const previewImg = subcatPanel.querySelector('[data-preview-img]');
      const previewVideo = subcatPanel.querySelector('[data-preview-video]');
      const previewCaption = subcatPanel.querySelector('[data-preview-caption]');
      const defaultImage = subcatPanel.getAttribute('data-default-image');
      const defaultVideo = subcatPanel.getAttribute('data-default-video');

      function showProductPreview(imageUrl, productTitle) {
        if (previewVideo) {
          previewVideo.style.display = 'none';
        }

        if (previewImg) {
          previewImg.classList.remove('mega-menu__preview-image--hidden');
          previewImg.classList.remove('mega-menu__preview-image--empty');
          previewImg.style.opacity = '0';
          setTimeout(() => {
            previewImg.src = imageUrl;
            previewImg.style.opacity = '1';
          }, 150);
        }

        if (previewCaption) {
          previewCaption.textContent = productTitle;
          previewCaption.classList.add('mega-menu__preview-caption--visible');
        }
      }

      function resetToDefault() {
        if (previewVideo && defaultVideo) {
          previewVideo.style.display = 'block';
          if (previewImg) {
            previewImg.classList.add('mega-menu__preview-image--hidden');
          }
        } else if (previewImg && defaultImage) {
          previewImg.classList.remove('mega-menu__preview-image--hidden');
          previewImg.classList.remove('mega-menu__preview-image--empty');
          previewImg.style.opacity = '0';
          setTimeout(() => {
            previewImg.src = defaultImage;
            previewImg.style.opacity = '1';
          }, 150);
        } else if (previewImg) {
          previewImg.classList.add('mega-menu__preview-image--empty');
          previewImg.src = '';
        }

        if (previewCaption) {
          previewCaption.textContent = '';
          previewCaption.classList.remove('mega-menu__preview-caption--visible');
        }
      }

      subcategoryItems.forEach(item => {
        item.addEventListener('mouseenter', function() {
          const productImage = this.getAttribute('data-product-image');
          const productTitle = this.getAttribute('data-product-title');

          subcategoryItems.forEach(si => {
            si.classList.remove('mega-menu__subcategory-item--active');
          });
          this.classList.add('mega-menu__subcategory-item--active');

          if (productImage && productTitle) {
            showProductPreview(productImage, productTitle);
          } else {
            resetToDefault();
          }
        });
      });

      const subcategoryList = subcatPanel.querySelector('.mega-menu__subcategories-list');
      if (subcategoryList) {
        subcategoryList.addEventListener('mouseleave', function() {
          resetToDefault();
          subcategoryItems.forEach((si, index) => {
            if (index === 0) {
              si.classList.add('mega-menu__subcategory-item--active');
            } else {
              si.classList.remove('mega-menu__subcategory-item--active');
            }
          });
        });
      }
    });
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (activePanel) {
        closeMegaMenu();
      }
      if (helpMenuPanel && helpMenuPanel.classList.contains('active')) {
        closeHelpMenu();
      }
    }
  });

  const helpMenuTrigger = document.querySelector('[data-help-menu-trigger]');
  const helpMenuPanel = document.querySelector('[data-help-menu-panel]');

  function openHelpMenu() {
    if (!helpMenuPanel) return;

    if (activePanel) {
      closeMegaMenu();
    }

    helpMenuPanel.classList.add('active');
    helpMenuPanel.setAttribute('aria-hidden', 'false');
    if (megaMenuOverlay) megaMenuOverlay.classList.add('active');
    if (helpMenuTrigger) {
      helpMenuTrigger.classList.add('active');
      helpMenuTrigger.setAttribute('aria-expanded', 'true');
    }
  }

  function closeHelpMenu() {
    if (!helpMenuPanel) return;

    if (helpMenuPanel.contains(document.activeElement)) {
      document.activeElement.blur();
    }

    helpMenuPanel.classList.remove('active');
    helpMenuPanel.setAttribute('aria-hidden', 'true');
    if (megaMenuOverlay) megaMenuOverlay.classList.remove('active');
    if (helpMenuTrigger) {
      helpMenuTrigger.classList.remove('active');
      helpMenuTrigger.setAttribute('aria-expanded', 'false');
    }
  }

  let helpMenuCloseTimeout = null;

  function clearHelpMenuTimeout() {
    if (helpMenuCloseTimeout) {
      clearTimeout(helpMenuCloseTimeout);
      helpMenuCloseTimeout = null;
    }
  }

  if (helpMenuTrigger && helpMenuPanel) {
    helpMenuTrigger.addEventListener('mouseenter', function(e) {
      clearHelpMenuTimeout();
      openHelpMenu();
    });

    helpMenuTrigger.addEventListener('mouseleave', function(e) {
      helpMenuCloseTimeout = setTimeout(() => {
        closeHelpMenu();
      }, 150);
    });

    helpMenuPanel.addEventListener('mouseenter', function() {
      clearHelpMenuTimeout();
    });

    helpMenuPanel.addEventListener('mouseleave', function() {
      helpMenuCloseTimeout = setTimeout(() => {
        closeHelpMenu();
      }, 150);
    });
  }

  if (megaMenuOverlay) {
    megaMenuOverlay.addEventListener('click', function() {
      if (helpMenuPanel && helpMenuPanel.classList.contains('active')) {
        closeHelpMenu();
      }
    });
  }

  const storiesMenuTriggers = document.querySelectorAll('[data-stories-menu-trigger]');
  const storiesMenuPanels = document.querySelectorAll('[data-stories-menu-panel]');

  let activeStoriesPanel = null;

  function openStoriesMenu(index) {
    const panel = document.querySelector(`[data-stories-menu-panel="${index}"]`);
    const trigger = document.querySelector(`[data-stories-menu-trigger="${index}"]`);

    if (!panel) return;

    if (activePanel) {
      closeMegaMenu();
    }

    if (helpMenuPanel && helpMenuPanel.classList.contains('active')) {
      closeHelpMenu();
    }

    if (activeStoriesPanel && activeStoriesPanel !== panel) {
      closeStoriesMenu();
    }

    panel.classList.add('active');
    if (megaMenuOverlay) megaMenuOverlay.classList.add('active');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    activeStoriesPanel = panel;
  }

  function closeStoriesMenu() {
    if (!activeStoriesPanel) return;

    activeStoriesPanel.classList.remove('active');
    if (megaMenuOverlay) megaMenuOverlay.classList.remove('active');

    storiesMenuTriggers.forEach(trigger => {
      trigger.setAttribute('aria-expanded', 'false');
    });

    activeStoriesPanel = null;
  }

  let storiesMenuCloseTimeout = null;

  function clearStoriesMenuTimeout() {
    if (storiesMenuCloseTimeout) {
      clearTimeout(storiesMenuCloseTimeout);
      storiesMenuCloseTimeout = null;
    }
  }

  storiesMenuTriggers.forEach(trigger => {
    trigger.addEventListener('mouseenter', function(e) {
      clearStoriesMenuTimeout();
      const index = this.getAttribute('data-stories-menu-trigger');
      openStoriesMenu(index);
    });

    trigger.addEventListener('mouseleave', function(e) {
      storiesMenuCloseTimeout = setTimeout(() => {
        closeStoriesMenu();
      }, 150);
    });
  });

  storiesMenuPanels.forEach(panel => {
    panel.addEventListener('mouseenter', function() {
      clearStoriesMenuTimeout();
    });

    panel.addEventListener('mouseleave', function() {
      storiesMenuCloseTimeout = setTimeout(() => {
        closeStoriesMenu();
      }, 150);
    });
  });

  document.querySelectorAll('[data-stories-menu-close]').forEach(closeBtn => {
    closeBtn.addEventListener('click', closeStoriesMenu);
  });

  if (megaMenuOverlay) {
    megaMenuOverlay.addEventListener('click', function() {
      if (activeStoriesPanel) {
        closeStoriesMenu();
      }
    });
  }

  storiesMenuPanels.forEach(panel => {
    const articleItems = panel.querySelectorAll('[data-stories-article-item]');
    const previewImage = panel.querySelector('[data-preview-image]');
    const previewCategory = panel.querySelector('[data-preview-category]');
    const previewReadingTime = panel.querySelector('[data-preview-reading-time]');

    articleItems.forEach(item => {
      item.addEventListener('mouseenter', function() {
        const imageUrl = this.getAttribute('data-article-image');
        const category = this.getAttribute('data-article-category');
        const readingTime = this.getAttribute('data-article-reading-time');

        articleItems.forEach(ai => {
          ai.classList.remove('stories-menu__article-item--active');
        });
        this.classList.add('stories-menu__article-item--active');

        if (previewImage && imageUrl) {
          previewImage.style.opacity = '0';
          setTimeout(() => {
            previewImage.src = imageUrl;
            previewImage.style.opacity = '1';
          }, 150);
        }

        if (previewCategory && category) {
          previewCategory.textContent = category;
        }

        if (previewReadingTime && readingTime) {
          previewReadingTime.textContent = readingTime;
        }
      });
    });
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && activeStoriesPanel) {
      closeStoriesMenu();
    }
  });

  const headerSearch = document.querySelector('[data-header-search]');
  const searchInput = document.querySelector('[data-search-input]');
  const searchPanel = document.querySelector('[data-search-panel]');
  const searchProductsGrid = document.querySelector('[data-search-products]');
  const searchIcon = document.querySelector('[data-search-icon]');
  const searchSuggestionsList = document.querySelector('[data-search-suggestions]');

  let searchTimeout = null;
  let isSearchActive = false;
  const defaultSuggestionsHTML = searchSuggestionsList ? searchSuggestionsList.innerHTML : '';
  const defaultProductsHTML = searchProductsGrid ? searchProductsGrid.innerHTML : '';

  function openSearch() {
    if (isSearchActive) return;

    if (activePanel) closeMegaMenu();
    if (helpMenuPanel && helpMenuPanel.classList.contains('active')) closeHelpMenu();
    if (activeStoriesPanel) closeStoriesMenu();

    headerSearch.classList.add('active');
    searchPanel.classList.add('active');
    if (megaMenuOverlay) megaMenuOverlay.classList.add('active');
    searchInput.focus();
    isSearchActive = true;
  }

  function closeSearch() {
    if (!isSearchActive) return;

    headerSearch.classList.remove('active');
    searchPanel.classList.remove('active');
    if (megaMenuOverlay) megaMenuOverlay.classList.remove('active');
    searchInput.value = '';
    isSearchActive = false;

    if (searchSuggestionsList) searchSuggestionsList.innerHTML = defaultSuggestionsHTML;
    if (searchProductsGrid) searchProductsGrid.innerHTML = defaultProductsHTML;
  }

  if (searchIcon) {
    searchIcon.addEventListener('click', function(e) {
      e.stopPropagation();
      if (isSearchActive) {
        closeSearch();
      } else {
        openSearch();
      }
    });
  }

  if (headerSearch && searchInput) {
    headerSearch.addEventListener('click', function(e) {
      if (e.target.closest('[data-search-icon]')) return;
      if (!isSearchActive) openSearch();
    });

    searchInput.addEventListener('input', function(e) {
      const query = e.target.value.trim();

      if (searchTimeout) clearTimeout(searchTimeout);

      if (query.length < 2) {
        if (searchSuggestionsList) searchSuggestionsList.innerHTML = defaultSuggestionsHTML;
        if (searchProductsGrid) searchProductsGrid.innerHTML = defaultProductsHTML;
        return;
      }

      searchTimeout = setTimeout(() => {
        performPredictiveSearch(query);
      }, 300);
    });

    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        const query = searchInput.value.trim();
        if (query) {
          window.location.href = '/search?q=' + encodeURIComponent(query);
        }
      }
    });
  }

  async function performPredictiveSearch(query) {
    try {
      const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=hide`);
      const data = await response.json();

      const products = data.resources?.results?.products || [];

      if (searchSuggestionsList && products.length > 0) {
        const suggestionsHTML = products.map((product) => {
          return `<a href="${product.url}" class="search-panel__suggestion-item" data-suggestion-item>${product.title}</a>`;
        }).join('');
        searchSuggestionsList.innerHTML = suggestionsHTML;
      } else if (searchSuggestionsList) {
        searchSuggestionsList.innerHTML = '<span class="search-panel__suggestion-item">No results found</span>';
      }

      if (searchProductsGrid && products.length > 0) {
        const displayProducts = products.slice(0, 3);
        const productsHTML = displayProducts.map(product => {
          const imageUrl = product.featured_image?.url || '';
          const imageHTML = imageUrl
            ? `<img src="${imageUrl}" alt="${product.title}" loading="lazy" width="140" height="180">`
            : '';
          return `<a href="${product.url}" class="search-panel__product-item" data-product-item>${imageHTML}</a>`;
        }).join('');
        searchProductsGrid.innerHTML = productsHTML;
      } else if (searchProductsGrid) {
        searchProductsGrid.innerHTML = defaultProductsHTML;
      }
    } catch (error) {
      console.error('Search error:', error);
      if (searchSuggestionsList) searchSuggestionsList.innerHTML = defaultSuggestionsHTML;
      if (searchProductsGrid) searchProductsGrid.innerHTML = defaultProductsHTML;
    }
  }

  let searchCloseTimeout = null;

  function clearSearchTimeout() {
    if (searchCloseTimeout) {
      clearTimeout(searchCloseTimeout);
      searchCloseTimeout = null;
    }
  }

  if (searchPanel) {
    searchPanel.addEventListener('mouseenter', function() {
      clearSearchTimeout();
    });

    searchPanel.addEventListener('mouseleave', function() {
      if (document.activeElement === searchInput) return;

      searchCloseTimeout = setTimeout(() => {
        closeSearch();
      }, 150);
    });
  }

  if (headerSearch) {
    headerSearch.addEventListener('mouseleave', function() {
      if (document.activeElement === searchInput) return;

      searchCloseTimeout = setTimeout(() => {
        closeSearch();
      }, 150);
    });

    headerSearch.addEventListener('mouseenter', function() {
      clearSearchTimeout();
    });
  }

  if (megaMenuOverlay) {
    megaMenuOverlay.addEventListener('click', function() {
      if (isSearchActive) {
        closeSearch();
      }
    });
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isSearchActive) {
      closeSearch();
    }
  });

  document.addEventListener('click', function(e) {
    if (isSearchActive && !headerSearch.contains(e.target) && !searchPanel.contains(e.target)) {
      closeSearch();
    }
  });

  const mobileSearchTrigger = document.querySelector('[data-mobile-search-trigger]');
  const mobileSearchOverlay = document.querySelector('[data-mobile-search-overlay]');
  const mobileSearchInput = document.querySelector('[data-mobile-search-input]');
  const mobileSearchCloseButtons = document.querySelectorAll('[data-mobile-search-close]');
  const mobileSuggestionsList = document.querySelector('[data-mobile-suggestions-list]');
  const mobileSearchProducts = document.querySelector('[data-mobile-search-products]');

  let mobileSearchTimeout = null;
  const defaultMobileSuggestionsHTML = mobileSuggestionsList ? mobileSuggestionsList.innerHTML : '';
  const defaultMobileProductsHTML = mobileSearchProducts ? mobileSearchProducts.innerHTML : '';

  function openMobileSearch() {
    if (mobileSearchOverlay) {
      mobileSearchOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      if (mobileSearchInput) {
        setTimeout(() => mobileSearchInput.focus(), 100);
      }
    }
  }

  function closeMobileSearch() {
    if (mobileSearchOverlay) {
      mobileSearchOverlay.classList.remove('active');
      document.body.style.overflow = '';
      if (mobileSearchInput) {
        mobileSearchInput.value = '';
      }
      if (mobileSuggestionsList) mobileSuggestionsList.innerHTML = defaultMobileSuggestionsHTML;
      if (mobileSearchProducts) mobileSearchProducts.innerHTML = defaultMobileProductsHTML;
    }
  }

  if (mobileSearchTrigger) {
    mobileSearchTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openMobileSearch();
    });
    mobileSearchTrigger.addEventListener('touchend', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openMobileSearch();
    });
  }

  mobileSearchCloseButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      closeMobileSearch();
    });
    button.addEventListener('touchend', function(e) {
      e.preventDefault();
      closeMobileSearch();
    });
  });

  if (mobileSearchInput) {
    mobileSearchInput.addEventListener('input', function(e) {
      const query = e.target.value.trim();

      if (mobileSearchTimeout) clearTimeout(mobileSearchTimeout);

      if (query.length < 2) {
        if (mobileSuggestionsList) mobileSuggestionsList.innerHTML = defaultMobileSuggestionsHTML;
        if (mobileSearchProducts) mobileSearchProducts.innerHTML = defaultMobileProductsHTML;
        return;
      }

      mobileSearchTimeout = setTimeout(() => {
        performMobileSearch(query);
      }, 300);
    });

    mobileSearchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        const query = mobileSearchInput.value.trim();
        if (query) {
          window.location.href = '/search?q=' + encodeURIComponent(query);
        }
      }
      if (e.key === 'Escape') {
        closeMobileSearch();
      }
    });
  }

  async function performMobileSearch(query) {
    try {
      const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=hide`);
      const data = await response.json();

      const products = data.resources?.results?.products || [];

      if (mobileSuggestionsList && products.length > 0) {
        const suggestionsHTML = products.map((product) => {
          return `<a href="${product.url}" class="mobile-search-overlay__suggestion-item">${product.title}</a>`;
        }).join('');
        mobileSuggestionsList.innerHTML = suggestionsHTML;
      } else if (mobileSuggestionsList) {
        mobileSuggestionsList.innerHTML = '<span class="mobile-search-overlay__suggestion-item">No results found</span>';
      }

      if (mobileSearchProducts && products.length > 0) {
        const displayProducts = products.slice(0, 3);
        const productsHTML = displayProducts.map(product => {
          const imageUrl = product.featured_image?.url || '';
          const imageHTML = imageUrl
            ? `<img src="${imageUrl}" alt="${product.title}" loading="lazy">`
            : '';
          return `<a href="${product.url}" class="mobile-search-overlay__product-item">${imageHTML}</a>`;
        }).join('');
        mobileSearchProducts.innerHTML = productsHTML;
      } else if (mobileSearchProducts) {
        mobileSearchProducts.innerHTML = defaultMobileProductsHTML;
      }
    } catch (error) {
      console.error('Mobile search error:', error);
      if (mobileSuggestionsList) mobileSuggestionsList.innerHTML = defaultMobileSuggestionsHTML;
      if (mobileSearchProducts) mobileSearchProducts.innerHTML = defaultMobileProductsHTML;
    }
  }
});
